"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Client = require("results-hub-client");
exports.ResultsHubClient = Client;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-client/dist/src/results-hub/index.js
 ** module id = 953
 ** module chunks = 0
 **/